<template>
    <div class="openclass-live">
        <div class="live-content">
            <div class="live-banner-bgc">
                <div class="class-live-banner maxW clear">
                    <div class="fl live-banner-tit">
                        <i class="ipng Shape_07" @click="goback()"></i>
                        <strong>{{ videoName }}</strong>
                    </div>
                </div>
                <div class="video-play-cont maxW">
                    <div class="video-box">
                        <div id="newMarkDom">
				            <!-- <video v-if="videoFlag" id="videoMarkPlayer" ref="videoMarkPlayer" class="video-js vjs-big-play-centered vjs-fluid"
                            width="100%" height="100%" crossorigin="anonymous"></video> -->
                            <DPlayer v-if="videoFlag" :options.sync="courseData"></DPlayer>
                        </div>
                    </div>
                </div>
            </div>
            <div class="live-commont maxW clear">
                <div class="live-commont-l fl">
                    <template>
                        <el-tabs v-model="activeName1">
                            <el-tab-pane :label="$t('homepage.classIntr')" name="first">
                                <div class="i_reviewArea_i clear">
									<span>
										<i class="video01"></i>
										<em id="video_clicks">{{ courseData.clicks }}{{ $t('global.play') }}</em>
									</span>
                                    <span>
										<i class="comment01"></i>
										<em id="video_clicks">{{ courseData.comments + $t('homepage.comments') }}</em>
									</span>
                                    <span>
										<i class="download01"></i>
										<em id="video_downloads">{{ courseData.downloads }}{{ $t('global.download') }}</em>
									</span>
                                </div>
                                <ul>
                                    <li class="i_reviewArea_ls clear">
                                        <span class="review-ls-tit">{{ $t('global.keyword') }}</span>
                                        <div class="video_keyword">
                                            <template v-if="courseData.keywords != null">
                                                <span v-for="(item, index) in courseData.keywords" :key="index">{{ item }}</span>
                                            </template>
                                            <span v-else>{{ $t('global.nokeyword') }}</span>
                                        </div>
                                    </li>
                                    <li class="i_reviewArea_ls clear">
                                        <span class="review-ls-tit">{{ $t('homepage.videoCate') }}</span>
                                        <div class="video_category"><span v-html="courseData.cate_name ? courseData.cate_name : $t('global.defaultSort')"></span></div>
                                    </li>
                                    <li class="i_reviewArea_ls clear">
                                        <span class="review-ls-tit">{{ $t('global.keepTime') }}</span>
                                        <div class="video_profile">
                                            <span>{{ saveTime(courseData.save_month) }}</span>
                                        </div>
                                    </li>
                                    <li class="i_reviewArea_ls clear">
                                        <span class="review-ls-tit">{{ $t('homepage.videoNotice') }}</span>
                                        <div class="video_notice"><span v-html="courseData.notice ? courseData.notice : $t('global.noData')"></span></div>
                                    </li>
                                    <li class="i_reviewArea_ls clear">
                                        <span class="review-ls-tit">{{ $t('homepage.videoIntr') }}</span>
                                        <div class="video_profile"><span v-html="courseData.profile ? courseData.profile : $t('global.noData')"></span></div>
                                    </li>
                                </ul>
                            </el-tab-pane>
                            <el-tab-pane :label="$t('homepage.teacherIntr')" name="second">
                                <ul>
                                    <li class="i_reviewArea_ls clear">
                                        <span class="review-ls-tit" :title="$t('homepage.teacherInfo')">{{ $t('homepage.teacherInfo') }}</span>
                                        <div class="user_info">
                                            <div class="i_teacherHs clear">
                                                <a class="ipng head fl">
                                                    <img v-if="courseData.avatar_path" src="../../../assets/images/morentouxiang.png" />
                                                </a>
                                                <div class="fl">
                                                    <span>{{ courseData.custom_speaker }}</span>
                                                    <span>
														{{ courseData.teacher_org_name }}
														<i v-if="courseData.teacher_org_name != '' && courseData.teacher_sub_name != ''">-</i>
														{{ courseData.teacher_sub_name }}
													</span>
                                                </div>
                                            </div>
                                        </div>
                                    </li>
                                    <li class="i_reviewArea_ls clear">
                                        <span class="review-ls-tit" :title="$t('homepage.teacherIntr')">{{ $t('homepage.teacherIntr') }}</span>
                                        <div class="user_profile">
                                            <p>{{ courseData.user_profile }}</p>
                                            <p v-if="courseData.user_profile == ''">{{ $t('global.noData') }}</p>
                                        </div>
                                    </li>
                                    <li class="i_reviewArea_ls clear">
                                        <span class="review-ls-tit">{{ $t('homepage.otherClass') }}</span>
                                        <div class="teacher_video">
                                            <template v-for="(item, index) in otherVideoData">
                                                <router-link :key="index" :to="{ path: 'openclassDetail', query: { id: item.id } }" target="_blank">
                                                    {{ item.video_name }}
                                                </router-link>
                                            </template>
                                        </div>
                                    </li>
                                </ul>
                            </el-tab-pane>
                            <el-tab-pane :label="$t('homepage.comment')" name="third">
                                <div class="discuss-area clear" v-if="!comment_flag">
                                    <div class="block">
                                        <span class="stration">{{ $t('homepage.grading') }}：</span>
                                        <el-rate :allow-half="true" v-model="classSore"></el-rate>
                                    </div>
                                    <div class="textarea">
                                        <el-input type="textarea" :rows="5" resize="none" v-model="profile"
                                             maxlength="140" :placeholder="$t('homepage.profileHolder') + '~'"></el-input>
                                        <span class="numberWord"><i>{{ profile.length }}</i>/140</span>
                                    </div>
                                    <el-button class="fr" size="small" type="primary" @click="addComent">{{ $t('homepage.yes') }}</el-button>
                                </div>
                                <div class="commont-list clear">
                                    <div class="commont-list-top">
                                        <span>{{ $t('homepage.comments') }}</span>
                                        <el-button type="text" @click="sortingData()">
                                            {{ $t('homepage.time') }}
                                            <i :class="[sortFlag ? 'el-icon-sort-down sortGery' : 'el-icon-sort-down']"></i>
                                            <i :class="[sortFlag ? 'el-icon-sort-up' : 'el-icon-sort-up sortGery']"></i>
                                        </el-button>
                                    </div>
                                    <ul>
                                        <li class="comment-ls" v-for="(item, index) of commentListData" :key="index">
                                            <div class="comment-ls-content clear">
                                                <a class="reviewer_img fl" href="javascript:;">
                                                    <img class :src="BASE_URL + item.avatar_path"/></a>
                                                <div class="reviewer-info">
                                                    <div class="i_videoReview_ip clear">
                                                        <div class="reviewer fl">
                                                            <a href="javascript:;">{{ item.username }}</a>
                                                            <el-rate :allow-half="true" disabled
                                                                     :value="item.score / 2"></el-rate>
                                                        </div>
                                                        <div class="create-time fr">
                                                            <i v-if="item.userid == user_login_id"
                                                               class="ipng but_edit01 i_editBt edit_comment" :title="$t('homepage.edit')"
                                                               @click="editComent(item)"></i>
                                                            <i v-if="item.userid == user_login_id"
                                                               class="ipng but_del i_editDl del_comment" :title="$t('homepage.delete')"
                                                               @click="delComent(item.id)"></i>
                                                            <span>{{ item.create_time }}</span>
                                                        </div>
                                                    </div>
                                                    <div class="review-text clear">
                                                        <p>{{ item.content }}</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </li>
                                    </ul>
                                </div>
                            </el-tab-pane>
                        </el-tabs>
                    </template>
                </div>
                <div class="live-commont-r fr">
                    <div class="i_reviewArea_pd">
                        <div class="i_dataDownload_t"><span>{{ $t('homepage.downloadRes') }}</span></div>
                        <div class="i_dataDownload_c">
                            <ul id="video_file">
                                <li class="dataFile clear" v-for="(item, index) of videoFileData" :key="index">
                                    <a href="javascript:;">{{ item.name.split('.')[1] ? item.name : item.name + '.' + item.attachemnt_path.split('.')[1] }}</a>
                                    <i class="ipng but_doland02_slide" @click="videoFileDownload(item)"></i>
                                </li>
                            </ul>
                            <div class="dataFileBG" v-if="videoFileData.length == 0">
                                <span>- {{ $t('global.noData') }} -</span>
                            </div>
                            <div class="pageBox">
                                <el-pagination small background v-if="total_number1 > page_size1" @current-change="change_page(page_index1, '1')"
                                            :page-size="page_size1" :current-page.sync="page_index1" layout="prev, pager, next" :total="total_number1"></el-pagination>
                            </div>
                        </div>
                    </div>
                    <div class="i_reviewArea_pd">
                        <div class="i_dataDownload_t"><span>{{ $t('homepage.watched') }}</span></div>
                        <div class="i_dataDownload_c">
                            <div class="dataUser clear" id="video_record">
                                <el-popover placement="top" trigger="hover" v-for="(item, index) of sawPeopleData" :key="index">
                                    <div class="i_userIn">
                                        <div class="i_userIn_txt clear">
                                            <img class="avatar-pic fl" :src="BASE_URL + item.avatar_path" />
                                            <div class="saw-people-info">
                                                <span>{{ item.username }}</span>
                                                <span>{{ item.message[0].org_name }}</span>
                                                <span>{{ item.message[0].company_position_name }}</span>
                                            </div>
                                        </div>
                                    </div>
                                    <el-button class="saw-btn" type="text" slot="reference">
                                        <a href="javascript:;">
                                            <img class="r-avatar-img" :src="BASE_URL + item.avatar_path" />
                                        </a>
                                    </el-button>
                                </el-popover>
                            </div>
                            <div class="dataFileBG2" v-if="sawPeopleData.length == 0">
                                <p>- {{ $t('global.noData') }} -</p>
                            </div>
                            <div class="pageBox">
                                <el-pagination small background v-if="total_number2 > page_size2" @current-change="change_page(page_index2, '2')"
                                               :page-size="page_size2" :current-page.sync="page_index2" layout="prev, pager, next" :total="total_number2"></el-pagination>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <el-dialog
      :title="$t('global.warningTitle')"
      class="share_dialog"
      :visible.sync="isRead"
      width="550px"
      :close-on-click-modal="false"
      :show-close="false"
    >
      <div style="line-height:1.4rem;height:4rem;font-size: 1.1rem;">{{ $t('global.warning') }}</div>
      <el-button
        class="copy_btn"
        type="primary"
        @click="isRead = false"
      >{{
        $t("global.sure")
      }}</el-button>
    </el-dialog>
    </div>
</template>
<script>
import 'videojs-flash';
import '../../../assets/js/zh-CN';
import axios from 'axios'
import DPlayer from "../../../components/common/DPlayer.vue"
export default {
    components: {
        DPlayer,
    },
    data() {
        return {
            isRead: false,
            user_login_id: sessionStorage.getItem('user_info_str') && JSON.parse(sessionStorage.getItem('user_info_str')).id,
            videoid: this.$route.query.id,
            is_download: this.$route.query.is_download,
            is_complete: 0, // 0是未经过专辑进入观看视频的，1：经过专辑进入观看视频，未看完；2：经过专辑进入观看视频，已看完',
            // 从优课专辑跳到此页面：
            album_id: this.$route.query.album_id,
            ablumInterval: null,
            cutid: this.$route.query.cutId,
            videoName: '',
            videoFlag: false,
            player: null, // 播放器

            playerOptions: {
                loop: false, // true -- 视频一结束就重新开始
                controls: true,
                autoplay: true, // true--浏览器准备好时开始回放
                height: '360',
                poster: '', // 封面地址
                language: 'zh-CN',
                sources: [{
                    type: 'application/x-mpegURL', // 类型
                    src: 'bbbbb' // 视频播放路径
                }],
                controlBar: {
                    children: [{
                        name: 'playToggle'
                    }, // 播放按钮
                    {
                        name: 'currentTimeDisplay'
                    }, // 当前已播放时间
                    {
                        name: 'progressControl'
                    }, // 播放进度条
                    {
                        name: 'durationDisplay'
                    }, // 总时间
                    {
                        name: 'volumePanel', // 音量控制
                        inline: false // 不使用水平方式
                    },
                    {
                        name: 'FullscreenToggle'
                    } // 全屏
                    ]
                }
            },
            videoCurrentTime: 0, //实时获取到的视频播放进度，带小数点的毫秒数
            activeName1: 'first',
            classSore: 0,
            profile: '',
            //课程介绍 / 讲师介绍：
            lengthString: '', //视频长度 字符串 格式"00:00:00"
            videolength: 0,
            courseData: {},
            otherVideoData: [],

            // 视频资源下载：
            videoFileData: [],
            page_index1: 1,
            page_size1: 3,
            total_number1: 0,
            // 观看过的人：
            sawPeopleData: [],
            page_index2: 1,
            page_size2: 20,
            total_number2: 0,


            //分辨率
            resolutionOption: {},
            resolution: '',
            timer: null,
            checkResolutionStatus: false,
            showAlert: false, // 若$alert弹窗显示时值为true，反则为false
            showShare: false, //显示分享弹窗
            shareLink: '', // 分享地址
            changeCopy: 1, // 选择复制

            //评分评论
            sortFlag: true,
            comment_id: null,
            comment_flag: false,
            page_index: 1,
            page_size: 5,
            order_type: 'time_down',
            commentListData: [],
            total_number: 0,
            o_imgChecked: false,
            screenshotUrl: '',//截图图片路径
            uploadOptions: {
                target: this.BASE_URL + "/api/resource/res_upload",
                headers: { Authorization: `Bearer ` + this.$g.access_token },
                testChunks: false,
                allowDuplicateUploads: true,
            },
            statusText: {
                success: this.$t('upload.success'),
                error: this.$t('upload.error'),
                uploading: this.$t('upload.uploading'),
                paused: this.$t('upload.paused'),
                waiting: this.$t('upload.waiting')
            },
        };
    },
    mounted() {
        if (this.isTencentCloud) {
            this.openRead();
        }
        this.getVideoDetail();
        this.getIntroduction();
        this.getSawPeople();
        this.getCommentList();
        this.checkVideoAuth();
    },
    beforeDestroy() {
        this.player && this.player.dispose();
    },
    destroyed() {
        clearInterval(this.ablumInterval);
    },
    computed: {
        saveTime() {
            return month => {
                if (month == 0) {
                    return this.$t('global.forever');
                } else if (month == 6) {
                    return this.$t('global.halfYear');
                } else if (month == 12) {
                    return this.$t('global.oneYear');
                } else {
                    return month + this.$t('global.month');
                }
            };
        },
        isTencentCloud() {
            return sessionStorage.getItem("tencentCloud") === "1" ? true : false;
        },
    },
    methods: {
        openRead() {
            this.isRead = true;
        },
        turnBack() {
            let user_id = JSON.parse(sessionStorage.getItem('user_info_str')) ? JSON.parse(sessionStorage.getItem('user_info_str')).id : ''

            let success = res => {
                if (res.data.islimit == 0) {
                    this.$message.closeAll()
                    this.$message.warning(this.$t('global.authorityMessage'))
                    setTimeout(() => {
                        this.$router.replace('/')
                    }, 2500);

                }
            }

            if (user_id) {
                this.$ajax.get('/api/video/get_islimit_by_video_user_id', { params: { type: 1, type_id: this.videoid, user_id, }, func: { success } })
            } else {
                this.$message.closeAll()
                this.$message.warning(this.$t('global.authorityMessage1'))
                setTimeout(() => {
                    this.$router.replace('/')
                }, 2500);
            }



        },
        checkVideoAuth() {
            let success = res => {
                let limit_type = res.data.limit_type
                console.log(limit_type)
                if (limit_type === 1) {
                    return
                } else {
                    this.turnBack();
                }
            }
            this.$ajax.get('/api/video/get_check_by_video_id', { params: { type: 1, type_id: this.videoid }, func: { success } })
        },
        //课程介绍
        getIntroduction(hasVideo) {
            let success = data => {
                // console.log(data.data,'cloud_file_id', '课程介绍')
                if (!data.data.transform_status && !this.showAlert) {
                    this.showAlert = true;
                    let content = this.$t('homepage.transcoding');
                    this.$alert(content, this.$t('global.tips'), {
                        confirmButtonText: this.$t('global.sure'),
                        callback: action => {
                            this.$router.back();
                            return false
                        }
                    });
                } else if (!data.data.transform_status && this.showAlert) {
                    return
                }

                this.courseData = data.data;
                this.videoFlag = true;
                this.videoName = data.data.name;

                this.comment_flag = Object.keys(data.data.mark_comment).length != 0;

                /**
                 * 通过 /api/video/video 获取去的 create_id 和userid 为0 时 不再请求//api/video/video_list  接口
                 * @DateTime 2020-03-14T10:43:12+0800
                 * @qiu_m
                 * @param    {[type]}                 data.data.userid !             [description]
                 * @return   {[type]}                                  [description]
                 */
                if (data.data.userid != 0 && data.data.create_id != 0) {
                    this.getTeacherVideo(data.data.userid);
                }

                if (data.data.status == 0) {
                    this.$message.error(this.$t('my.homepage.videoDeleted'));
                    this.$router.push('/openclass/');
                }
            };
            let fail = res => { }
            this.$ajax({
                url: 'api/video/video',
                method: 'get',
                params: {
                    video_sign: sessionStorage.getItem('video_sign'),
                    // videoid: this.videoid,
                    // userid: this.user_login_id,
                    // cutid: this.cutid
                },
                func: {
                    success, fail
                }
            });
        },
        //看过的人
        getSawPeople() {
            let success = res => {
                this.total_number2 = res.data.data_sum;
                this.sawPeopleData = res.data.data.slice(0, 15);
                // console.log(this.sawPeopleData)
            };
            this.$ajax({
                url: 'api/video/video_record_user',
                method: 'get',
                params: {
                    videoid: this.videoid,
                    page_index: this.page_index2,
                    page_size: this.page_size2
                },
                func: {
                    success: success
                }
            });
        },
        //获取讲师介绍：其他课程
        getTeacherVideo(_id) {
            let success = data => {
                this.otherVideoData = data.data.data;
            };
            this.$ajax({
                url: 'api/video/video_list',
                method: 'get',
                params: {
                    create_id: _id,
                    page_size: 3
                },
                func: {
                    success: success
                }
            });
        },
        //评论列表
        getCommentList() {
            let success = res => {
                this.total_number = parseInt(res.data.data_sum);
                this.page_index = parseInt(res.data.page_index);
                this.commentListData = res.data.data;
            };
            let fail = res => { }
            this.$ajax({
                url: 'api/video/video_comment_list',
                method: 'get',
                params: {
                    page_index: this.page_index,
                    page_size: this.page_size,
                    res_id: this.videoid,
                    order_type: this.order_type
                },
                func: {
                    success, fail
                }
            });
        },
        // 删除评论
        delComent(_id) {
            this.$confirm(this.$t('homepage.delCommentsWhat') + '?', this.$t('global.tips'), {
                confirmButtonText: this.$t('global.sure'),
                cancelButtonText: this.$t('global.cancel'),
                type: 'warning'
            })
                .then(() => {
                    let success = res => {
                        this.$message.success(this.$t('homepage.delSuccess'));
                        this.comment_flag = false;
                        this.comment_id = null;
                        this.classSore = 0;
                        this.profile = '';
                        this.getCommentList();
                        this.getIntroduction();
                    };
                    this.$ajax({
                        url: 'api/comment/comment',
                        method: 'delete',
                        params: {
                            id: _id
                        },
                        func: {
                            success: success
                        }
                    });
                })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: this.$t('homepage.notDel')
                    });
                });
        },
        // 发表评论
        addComent() {
            if (!this.user_login_id) {
                this.$message.warning(this.$t('homepage.needLogin'))
                return
            }
            if (this.profile == '' || this.profile.trim().length == 0) {
                this.$message.warning(this.$t('homepage.addComments'));
                return;
            }
            let _method, _params;
            if (this.comment_id != null) {
                _method = 'put';
                _params = {
                    id: this.comment_id,
                    user_id: this.user_login_id,
                    res_id: this.videoid,
                    origin: 0,
                    score: this.classSore * 2,
                    content: this.profile,
                    image_path: this.screenshotUrl
                };
            } else {
                _method = 'post';
                _params = {
                    user_id: this.user_login_id,
                    res_id: this.videoid,
                    origin: 0,
                    score: this.classSore * 2,
                    content: this.profile,
                    image_path: this.screenshotUrl
                };
            }

            let success = res => {
                this.comment_flag = true;
                this.o_imgChecked = false;
                this.screenshotUrl = "";
                this.$message.success(res.msg);
                this.getCommentList();
                this.getIntroduction();

            };
            this.$ajax({
                url: 'api/comment/comment',
                method: _method,
                data: _params,
                func: {
                    success: success
                }
            });
        },
        //评分评论：时间按钮
        sortingData() {
            this.sortFlag = !this.sortFlag;
            this.sortFlag == true ? (this.order_type = 'time_down') : (this.order_type = 'time_up');
        },

        // 删除评论
        delComent(_id) {
            this.$confirm(this.$t('homepage.delCommentsWhat') + '?', this.$t('global.tips'), {
                confirmButtonText: this.$t('global.sure'),
                cancelButtonText: this.$t('global.cancel'),
                type: 'warning'
            })
                .then(() => {
                    let success = res => {
                        this.$message.success(this.$t('homepage.delSuccess'));
                        this.comment_flag = false;
                        this.comment_id = null;
                        this.classSore = 0;
                        this.profile = '';
                        this.getCommentList();
                        this.getIntroduction();
                    };
                    this.$ajax({
                        url: 'api/comment/comment',
                        method: 'delete',
                        params: {
                            id: _id
                        },
                        func: {
                            success: success
                        }
                    });
                })
                .catch(() => {
                    this.$message({
                        type: 'info',
                        message: this.$t('homepage.notDel')
                    });
                });
        },
        // 编辑评论
        editComent(_item) {
            this.comment_flag = false;
            this.comment_id = _item.id;
            this.classSore = _item.score / 2;
            this.profile = _item.content;
            this.screenshotUrl = _item.image_path;
        },

        getVideoDetail() {
            let success = res => {
                sessionStorage.setItem('sharePath', this.BASE_URL + '/home/openclassDetail?id=' + res.data.id)
                this.lengthString = res.data.length; //视频长度
                this.videoFileData = res.data.attachment_info ? res.data.attachment_info : []

                this.isShoreUrl = res.data.path.includes('http') ? res.data.path : this.BASE_URL + '/' + res.data.path

                this.playerOptions.sources = [{
                    type: "video/mp4", // 类型
                    src: this.isShoreUrl // 视频播放路径
                }]

                // this.initPlay();
            }
            this.$ajax.get('api/video/video', {
                params: {
                    video_sign: sessionStorage.getItem('video_sign'),
                },
                func: { success }
            })
        },
        /**
         * 播放器初始
         */
        initPlay() {
            let self = this;
            this.player && this.player.dispose();
            let videoMarkPlayer = document.getElementById('newMarkDom');

            videoMarkPlayer.innerHTML =
                '<video id="videoMarkPlayer" class="video-js vjs-big-play-centered vjs-fluid" width="100%" height="100%" crossorigin="anonymous"> </video>';
            this.player = this.$videojs('videoMarkPlayer', this.playerOptions, function onPlayerReady() { });

            this.player.on('play', function () {
                self.onSlicePlay();
            });
            this.player.on('timeupdate', function () {
                self.onPlayerTimeupdate();
            });
            this.player.on('loadedmetadata', function () {
                self.onPlayerLoadeddata();
            });

        },
        /**
         * 改变进度条
         */
        onSlicePlay() {
            this.debounce(() => {
                var normal_currentTime = this.player.currentTime();
                var unnormal_currentTime = this.player.currentTime();
                if (normal_currentTime.toString() == unnormal_currentTime.toString()) {
                    this.player.pause();
                    this.player.play();
                }
            }, 100);
        },
        //延迟处理
        debounce(func, wait, immediate) {
            let timeout, args, context, timestamp, result;
            const later = function () {
                // 据上一次触发时间间隔
                const last = +new Date() - timestamp;

                // 上次被包装函数被调用时间间隔 last 小于设定时间间隔 wait
                if (last < wait && last > 0) {
                    timeout = setTimeout(later, wait - last);
                } else {
                    timeout = null;
                    // 如果设定为immediate===true，因为开始已经调用过了此处无需调用
                    if (!immediate) {
                        result = func.apply(context, args);
                        if (!timeout) context = args = null;
                    }
                }
            };
            return function (...args) {
                context = this;
                timestamp = +new Date();
                const callNow = immediate && !timeout;
                // 如果延时不存在，重新设定延时
                if (!timeout) timeout = setTimeout(later, wait);
                if (callNow) {
                    result = func.apply(context, args);
                    context = args = null;
                }

                return result;
            };
        },
        //实时获取视频播放的信息
        onPlayerTimeupdate() {
            //实时获取当前的播放进度时间（毫秒数，带小数点）
            this.videoCurrentTime = this.player.currentTime();
        },

        // 视频加载完毕装备就绪
        onPlayerLoadeddata() {
            this.videolength = this.player.duration(); //获取视频的长度
        },
        // 下载资料
        videoFileDownload(obj) {
            if (localStorage.getItem('token')) {

                var src = this.BASE_URL + '/index/openclass/download_video_file_huiyi?id=' + obj.id;
                var iframe = document.createElement('iframe');
                iframe.style.display = 'none';
                iframe.src = "javascript: '<script>location.href=\"" + src + "\"<\/script>'";
                document.getElementsByTagName('body')[0].appendChild(iframe);

            } else {
                this.$message.warning(this.$t('homepage.needLogin'))
            }
        },
        change_page(val, type) {
            if (type == '1') {
                this.page_index1 = val;
            } else if (type == '2') {
                this.page_index2 = val;
                this.getSawPeople();
            }
        },
        goback() {
            this.$router.push('/home/openclassList');
        }
    }
};
</script>
<style lang="scss">
@import url('../../../assets/css/video.css');

.transcoding {
    position: relative;
    width: 56px;
    cursor: pointer;

    >dl {
        position: absolute;
        bottom: 0;
        width: 100%;

        &:hover dd {
            display: block;
        }

        >dd {
            display: none;
            height: 42px;
            line-height: 42px;
            text-align: center;
            color: #fff;
            background: rgba(0, 0, 0, 0.4);

            &:hover {
                font-weight: 600;
                background: rgba(0, 0, 0, 0.8);
            }

        }

        >.acitve {
            height: 42px;
            line-height: 42px;
            text-align: center;
            color: #fff;
            // font-weight: 600;
            background: transparent;
        }

    }

}

.openclass-live {
    .video_profile {
        max-height: 350px;
        overflow: auto;

        >span>p {
            line-height: 1.5;
        }

        img {
            max-width: 100% !important;
            height: auto;
            object-fit: contain;
        }
    }

    .share_text {
        font-size: 16px;

        .el-radio-group {
            margin: 20px 0 15px 0;
        }

        .el-radio__label {
            font-size: 15px;
        }
    }

    .dotting_time {
        width: 138px;
        height: 54px;
        padding-top: 4px;
        color: #fff;
        text-align: center;
        line-height: 24px;
        background: rgba(0, 0, 0, 0.5);
        position: absolute;
        right: 20px;
        top: 20px;
        z-Index: 555;
        font-size: 14px;
        border-radius: 2px;

        p:nth-child(1) {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }
}

.live-banner-bgc {
    margin-top: 9%;
    position: relative;
    // background-image: url("../../../assets/images/bgc.png") !important;
    background-size: cover;
    width: 100%;
    overflow: hidden;
}

.class-live-banner {
    height: 50px;
    line-height: 50px;
    background: #fff;

    .live-banner-tit {
        font-size: 16px;
        cursor: pointer;
    }

    .Shape_07 {
        margin-left: 32px;
        margin-right: 10px;
    }

    i,
    strong,
    a {
        vertical-align: middle;
    }

    strong {
        margin-left: 15px;
        font-size: 20px;
        color: #fff;
        color: #000;
    }

    .live-banner-r {
        font-size: 14px;
        color: #b1bdc2;
        // margin-right: 30px;
    }

    .train-file-l-share>span {
        line-height: 20px;
        margin-right: 10px;
        font-size: 12px;
        color: #000;
    }

    .train-file-l-share>div {
        display: inline-block;
        vertical-align: middle;
    }

    .train-file-l-share>div>a {
        margin: 0 10px;
    }
}

.video-play-cont {
    margin-bottom: 50px;
}




.video-box {
    height: 674px;
    position: relative;

    #newMarkDom {
        height: 674px;
    }

    .waterMark {
        width: 168px;
        height: 54px;
        border-radius: 2px;
        background-color: #000;
        position: absolute;
        top: 10px;
        right: 10px;
        opacity: .5;
    }

    .videoMarkPlayer-dimensions.vjs-fluid {
        padding-top: 56%;
    }

    &:hover .resolution {
        visibility: visible;
        opacity: 1;
    }

    .resolution {
        visibility: hidden;
        opacity: 0;
        transition: visibility 1s, opacity 1s;
        width: 42px;
        height: 42px;
        line-height: 42px;
        position: absolute;
        right: 42px;
        bottom: 0;
        font-size: 12px;
        color: #fff;
        cursor: pointer;

        &:hover ul {
            display: block;
        }

        span {
            display: inline-block;
            width: 100%;
            height: 100%;
            text-align: center;
        }

        ul {
            display: none;
            width: 100%;
            position: absolute;
            right: 0;
            bottom: 42px;
            background-color: rgba(115, 133, 159, 0.5);

            li {
                height: 20px;
                line-height: 20px;
                text-align: center;

                &:hover {
                    background-color: rgba(115, 133, 159, 0.5);
                }
            }
        }
    }
}

.live-commont-l .el-tabs__content .el-tab-pane .i_reviewArea_i {
    margin-bottom: 27px;
}



.i_reviewArea_i>span>em {
    color: #666666;
    line-height: 16px;
    margin-top: 10px;
    display: block;
}

.i_reviewArea_ls {
    border-bottom: 1px solid #efefef;
    padding: 20px;
    min-height: 16px;
    line-height: 16px;

    &:first-child {
        border-top: 1px solid #efefef;
    }
}

.i_reviewArea_ls>div {
    float: left;
    width: 664px;
}

.i_reviewArea_ls>div>span {
    line-height: 19px;
    margin-right: 20px;
    color: #000;
}

.i_reviewArea_ls>div>a {
    color: #E62125;
    margin-right: 20px;
}

.common-bar {
    .question-bar-input {
        border-bottom: 1px solid #dcdfe6;
    }

    .el-tabs__header {
        margin: 0;
    }

    .el-tabs__item {
        width: 210px;
        padding: 0;
        text-align: center;
        transition: all .3s cubic-bezier(.645,.045,.355,1);
        border: 1px solid transparent;
    }

    .el-tabs__item.is-active {
        background-color: #a8ecfd;
    }

    .el-tabs__active-bar {
        display: none;
    }

    .textarea {
        margin: 20px 10px;
        position: relative;

        .numberWord {
            position: absolute;
            bottom: 10px;
            right: 10px;
        }
    }

    .cut-img {
        padding: 0 10px 20px;
        border-bottom: 1px solid #dcdfe6;
    }

    .but_addamage {
        margin-right: 10px;
    }

    .el-button {
        width: 80px;
    }

    .question-div {
        overflow-y: scroll;
    }

    .preson-question {
        height: 550px;
    }

    .all-question {
        height: 738px;
    }

    .comment-li-item {
        padding: 20px 0;
        margin: 0 20px;
        border-bottom: 1px solid #e0e0e0;

        a {
            display: block;
            float: left;
            width: 42px;
            height: 42px;
            border-radius: 50%;
            overflow: hidden;

            img {
                width: 100%;
                height: 100%;
                vertical-align: top;
            }
        }
    }

    .comment-li-box {
        float: none;
        margin-left: 60px;

        .comment-user {
            color: #666;
        }

        .textarea {
            margin: 20px 0;
        }
    }

    .comment-content {
        font-size: 14px;
        line-height: 21px;
        margin-bottom: 15px;
    }

    .comment-li-area {
        padding-bottom: 20px;
    }

    .img-card {
        position: relative;
        margin-bottom: 20px;

        .el-card__body {
            height: 100px;

            img {
                width: 100%;
                height: 100%;
            }
        }
    }

    .tips-word {
        visibility: hidden;
        opacity: 0;
        width: 100%;
        height: 140px;
        line-height: 140px;
        position: absolute;
        top: 0;
        left: 0;
        background-color: rgba(144, 147, 153, 0.5);
        text-align: center;

        span {
            padding: 20px;
            font-size: 20px;
            font-weight: 600;
            letter-spacing: 5px;
            border: 2px dashed #fff;
            color: #fff;
            cursor: pointer;
        }
    }

    .img-card .el-card__body:hover>.tips-word {
        visibility: visible;
        opacity: 1;
    }

    .comment-btns-tool {
        span {
            color: #2f6d8c;
        }

        i {
            cursor: pointer;
            margin-left: 15px;
            visibility: hidden;
        }
    }

    .comment-li-box:hover>.comment-btns-tool>i {
        visibility: visible;
    }

    .reply-tips {
        padding-top: 20px;
        box-sizing: border-box;

        span {
            display: block;
            padding: 10px 0;
            // color: #666;
            color: #E62125;
        }

        .role1 {
            color: #E62125;
        }
    }
}

.seePicDialog {
    .el-dialog__header {
        padding: 0;
    }

    .el-dialog__body {
        text-align: center;
    }

    .el-dialog__headerbtn {
        border-radius: 50%;
        top: -12px;
        right: -12px;
        padding: 3px;
        background-color: #fff;

        .el-dialog__close {
            padding: 3px;
            border-radius: 50%;
            background-color: #666;
            color: #fff;
        }

        .el-dialog__close:hover {
            background-color: #409eff;
        }
    }
}

// rightSideBar  end

// live-commont start

.live-commont {
    padding-bottom: 50px;
}

.live-commont-l {
    width: 900px;

    .el-tabs__header {
        // margin: 10px 0 10px;
        margin: 0;
        background: #fff;
        border-radius: 3px 3px 0px 0px;
        border-bottom: 1px solid #e4e7ed;
    }

    .el-tabs__nav-wrap::after,
    .el-tabs__active-bar {
        background-color: transparent;
    }

    .el-tabs__content {
        background-color: #fff;
        padding: 30px 35px 50px;

        .i_reviewArea_i {
            margin-bottom: 40px;

            span {
                display: block;
                float: left;
                text-align: center;
                margin-right: 100px;

                >i {
                    display: block;
                    width: 40px;
                    height: 40px;
                }

                em {
                    color: #666666;
                    line-height: 16px;
                    margin-top: 10px;
                    display: block;
                }
            }

            .video01 {
                background: url('../../../assets/images/icon_bofang@2x.png') no-repeat;
                background-size: contain;
            }

            .comment01 {
                background: url('../../../assets/images/icon_pinglun@2x.png') no-repeat;
                background-size: contain;
            }

            .download01 {
                background: url('../../../assets/images/icon_xiazai@2x.png') no-repeat;
                background-size: contain;
            }
        }
    }

    .i_reviewArea_ls {
        border-bottom: 1px solid #efefef;
        padding: 15px 0;

        .review-ls-tit {
            float: left;
            display: block;
            font-size: 14px;
            color: #666;
            width: 140px;
            margin-right: 8px;
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
        }

        .user_info,
        .user_profile,
        .teacher_video {
            float: left;
            width: 600px;

            a {
                color: #E62125;
                margin-right: 20px;
            }
        }

        .video_notice,
        .video_profile {
            word-wrap: break-word;
            word-break: break-all;
        }

        .user_profile p {
            word-wrap: break-word;
            word-break: break-all;
        }

        .i_teacherHs {
            span {
                display: block;
            }

            span:nth-of-type(1) {
                font-size: 16px;
                line-height: 25px;
            }

            a {
                cursor: auto;
            }

            img {
                width: 100%;
                height: 100%;
                border-radius: 50%;
            }
        }
    }

    .video_category span {
        margin-right: 0;
    }

    .discuss-area {

        .stration,
        .el-rate {
            vertical-align: middle;
            font-size: 14px;
        }

        .el-rate {
            display: inline-block;
            width: 80%;
        }

        .el-textarea__inner {
            font-size: 12px;
        }

        .textarea {
            margin: 20px 0;
            position: relative;

            .numberWord {
                position: absolute;
                bottom: 10px;
                right: 10px;
            }
        }
    }

    .commont-list-top {
        border-bottom: 1px solid #e0e0e0;

        span {
            font-size: 14px;
            margin-right: 20px;
        }

        .el-button {
            color: #000;
        }

        .sortGery {
            color: #338efc;
        }
    }

    .comment-ls {
        border-bottom: 1px solid #e0e0e0;
        padding: 20px 0;

        .reviewer_img {
            width: 42px;
            height: 42px;
            border-radius: 50%;
            overflow: hidden;
            display: block;
        }

        .reviewer-info {
            margin-left: 80px;
        }

        .i_videoReview_ip {
            line-height: 42px;
            margin-bottom: 20px;
            color: #666666;
        }

        .reviewer {
            a {
                margin-right: 20px;
                color: #666666;
                vertical-align: middle;
            }

            .el-rate {
                display: inline-block;
                vertical-align: middle;
            }
        }

        .create-time i,
        .create-time span {
            vertical-align: middle;
            margin-left: 20px;
        }

        .create-time i {
            cursor: pointer;
            visibility: hidden;
        }

        .review-text p {
            font-size: 14px;
            line-height: 18px;
            word-wrap: break-word;
            word-break: break-all;
        }
    }

    .pageBox {
        padding-top: 30px;
    }

    .comment-ls:hover .create-time>i {
        visibility: visible;
    }

    .el-tabs__header.is-top {
        height: 40px;

        .el-tabs__nav-wrap.is-top {
            .el-tabs__nav-scroll {
                height: 40px;

                .el-tabs__nav.is-top {
                    .el-tabs__item.is-top {
                        font-size: 14px;
                        padding: 0 15px;
                        color: #909399;
                        transition: all .3s cubic-bezier(.645,.045,.355,1);
                        border: 1px solid transparent;
                    }



                    .el-tabs__item.is-top.is-active {
                        color: #e62125;
                        font-weight: bold;
                        background-color: #fff;
                        border-right-color: #dcdfe6;
                        border-left-color: #dcdfe6;
                        margin-left: -1px !important;
                    }
                }
            }
        }
    }

    .el-tabs {
        .el-tabs__content {
            .el-tab-pane {
                &:nth-child(2) {
                    >ul {
                        .i_reviewArea_ls {
                            border-top: 0 none;

                            &:first-child {
                                padding: 0 0 26px;

                                .review-ls-tit {
                                    line-height: 48px;
                                }

                                .user_info {
                                    height: 48px;

                                    >div {
                                        >a {
                                            width: 48px;
                                            height: 48px;
                                        }

                                        >div>span {
                                            line-height: 48px;
                                        }
                                    }
                                }
                            }

                            &:nth-child(n + 2) {
                                min-height: 20px;
                                line-height: 20px;

                                .teacher_video {
                                    width: auto;

                                    >a {
                                        display: block;
                                        padding-bottom: 8px;
                                        width: auto;
                                        margin: 0;
                                        font-size: 14px;
                                        color: #E62125;

                                        &:last-child {
                                            padding: 0
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }
}

.live-commont-r {
    width: 280px;

    .i_reviewArea_pd {
        .i_dataDownload_t {
            padding: 0 20px;
            color: #fff;
            line-height: 40px;
            height: 40px;
            font-size: 14px;
            background: #2c2e3f;
            border-radius: 3px 3px 0px 0px;
            box-shadow: 0px 1px 1px 0px rgba(0, 0, 0, 0.1);
        }

        &:nth-child(n + 2) {
            margin-top: 20px;
        }
    }
}

.i_dataDownload_c {
    background: #ffffff;
    padding: 10px 0;
    position: relative;

    .el-pagination {
        padding: 2px 20px;
    }

    #video_file {
        padding: 5px;
    }
}

.saw-btn {
    margin: 0 4px 20px 0;
    padding: 0;

    .r-avatar-img {
        width: 40px;
        height: 40px;
        border-radius: 50%;
        background-color: #ccc;
        overflow: hidden;
    }
}

.saw-btn:nth-of-type(5n) {
    margin: 0 0 20px 0;
}

.el-popover {
    // background: rgba(80, 80, 80, 0.9);
    border: 0;

    .i_userIn {
        .i_userIn_txt {

            // padding: 25px 15px 30px;
            .avatar-pic {
                width: 30px;
                height: 30px;
                border-radius: 50%;
                background-color: #ccc;
                overflow: hidden;
            }
        }

        .but_Collection02 {
            background-position: -757px -300px;
            width: 40px;
            height: 40px;
        }

        .saw-people-info {
            float: left;
            margin-left: 15px;

            span:nth-of-type(1) {
                display: block;
                height: 30px;
                font-size: 14px;
                line-height: 24px;
                line-height: 30px;
                color: #000000;
                // color: #fff;
            }

            span:nth-of-type(2) {
                display: block;
                font-size: 12px;
                line-height: 24px;
                color: #666666;
                margin-right: 10px;
            }

            span:nth-of-type(2) {
                display: inline-block;
                font-size: 12px;
                line-height: 24px;
                color: #666666;
            }
        }
    }

}

.dataFile {
    padding: 5px 20px;
}

.dataFile {
    a {
        float: left;
        display: block;
        font-size: 14px;
        line-height: 40px;
        max-width: 60%;
    }

    i {
        float: right;
        border-radius: 50%;
        overflow: hidden;
        cursor: pointer;
    }

    i:hover {
        box-shadow: 0 6px 7px 0 rgba(0, 0, 0, 0.1);
    }
}

.dataFile:hover {
    background: #effaff;
}

.dataFile:hover>a {
    color: #67aed2;
}

.dataFileBG {
    text-align: center;
    padding: 35px 10px;

    span {
        font-size: 12px;
        line-height: 65px;
        color: #2f6d8c;
        color: #999;
    }
}

.dataUser {
    padding: 10px 25px;

    a {
        cursor: auto !important;
    }
}

.dataUser>a,
.dataUser>div {
    float: left;
    display: block;
    width: 40px;
    height: 40px;
    border-radius: 50%;
    margin: 0 7px 20px 0;
    background: #5cbeb3;
    position: relative;
}

.dataUser>a>img,
.dataUser>div>img {
    border-radius: 50%;
    width: 40px;
    height: 40px;
    vertical-align: top;
    overflow: hidden;
}

.dataUser>a:hover,
.dataUser>div:hover {
    box-shadow: 0 6px 7px 0 rgba(0, 0, 0, 0.1);
}

.dataUser>a:hover .i_userIn,
.dataUser>div:hover .i_userIn {
    opacity: 1;
    visibility: visible;
}

.dataUser>a:nth-of-type(5n),
.dataUser>div:nth-of-type(5n) {
    margin: 0 0 20px 0;
}

.dataFileBG2 {
    text-align: center;

    i {
        margin-top: 50px;
    }

    p {
        margin: 60px 0 50px;
        color: #2f6d8c;
        color: #999;
    }
}
</style>
